import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker} from 'google-maps-react';

class getOnlyviewUbication extends Component {
  constructor(props) {
    super(props);
    //this.mapRef = React.createRef();
    this.state = {
       edit:this.props.edit,
       markers: [
         {
           name: "Current position",
           position: {
             lat: this.props.lat,
             lng: this.props.lon
           }
         }
       ],
       mounted : false,
       mapStyles: [
     {
     "featureType": "administrative.neighborhood",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.man_made",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.natural",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.natural.landcover",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.natural.terrain",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.attraction",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.business",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.government",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.medical",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.park",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.place_of_worship",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.school",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.sports_complex",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "road.highway",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "road.local",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "transit.station",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "water",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     }
     ]
     };
  }
  /*


  */
  onMarkerDragEnd = (coord, index) => {


      const { latLng } = coord
      const lat = latLng.lat()
      const lng = latLng.lng()
      localStorage.lat_tmp =  lat
      localStorage.lon_tmp =  lng
      this.setState(prevState => {
        /*const markers = [...this.state.markers]
        markers[index] = [...markers[index], { position: { lat, lng } }]
        return { markers }*/
        const markers = [...this.state.markers];
        markers[index] = { ...markers[index], position: { lat, lng } };
        return { markers };
      });
      /*const markers = [...this.state.markers];
      markers[index] = { ...markers[index], position: { lat, lng } };
      return { markers };*/
    };

  render() {
    return (
      <React.Fragment>
          <Map
          className="pruebas"
          containerStyle={{
            position: 'relative',
            width: '100%',
            height: '100%'
          }}
          google={this.props.google}
          style={{
            position: 'relative',
            width:'100%',
            height:'100%'
          }}
          zoom={18}
          ref={this.mapRef}
          initialCenter={{ lat: this.props.lat, lng: this.props.lon }}
          disableDefaultUI ={true}
          styles={this.state.mapStyles}
          gestureHandling= {(this.state.edit)?'':'none'}
          zoomControl={(this.state.edit)?true:false}
          >
          {this.state.markers.map((marker, index) => (
            <Marker
              position={marker.position}
              draggable={(this.state.edit)?true:false}
              onDragend={(t, map, coord) => this.onMarkerDragEnd(coord, index)}
              name={marker.name}
              key={index}
            />
          ))}
          </Map>
        </React.Fragment>
    )
  }

  componentDidMount (){
    localStorage.lat_tmp =  this.props.lat
    localStorage.lon_tmp =  this.props.lon
  }

}
export default GoogleApiWrapper({
  apiKey: 'AIzaSyAtyO9FEIXPiDDSLE1a88MNGVpLKgxnxqo'
})(getOnlyviewUbication);
